export default {};
throw new Error(`Could not resolve "@react-three/fiber" imported by "@appletosolutions/reactbits". Is it installed?`)